/*
  lp-ddn2-sticky.js: page JS for sections/lp-dd-utcp-night-v2.liquid (UTC&P night Deep Dive v2).
  Lives in assets/ because the theme editor strips inline <script> from section markup.

  1. Guarded offer strings. Every B2G1 string is server-rendered in BOTH states:
       <span data-ddn2-fb>fallback</span><span data-ddn2-b2g1 hidden>B2G1</span>
     Only when the live 3-month card in the shared offer box reads "Buy 2, Get 1 FREE"
     (#uo-offer [data-f="plan3"] .uo-opt-t) are the two flipped. Never matches on "free" alone
     (the card checklist also says "Your 3rd bottle is free"). Watches #uo-offer for 10 s.
  2. Gift count: hides [data-ddn2-gifts] when #uo-offer[data-uo-sale-gifts] is "0".
  3. Page-owned sticky (#ddn2-sticky), mobile only (CSS): shows after 600px while the offer box
     is off-screen. State A (daily bladder care) until the live offer is confirmed;
     then state B (first month free), independent of cause-section progress.
  4. Lazy loops: video.ddn2-loop gets its src and plays near the viewport; pauses off-screen.
  5. Proof chart grow + count-up once at 40% visible (end state is server-rendered).
  6. Smooth scroll for in-page CTAs.
  Optional globals are always guarded (typeof window.fireEvent === 'function').
*/
(function () {
  'use strict';

  var root = document.querySelector('.ddn2');
  if (!root) return;

  var HEADER_OFFSET = 70;
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { /* ignore */ }

  function fire(name, payload) {
    if (typeof window.fireEvent === 'function') {
      try { window.fireEvent(name, payload || {}); } catch (e) { /* ignore */ }
    }
  }

  /* ---------- 1. Guarded B2G1 strings ---------- */
  var b2g1 = false;
  var B2G1_RE = /buy\s*2,\s*get\s*1\s*free/i;

  function cardSaysB2G1() {
    var t = document.querySelector('#uo-offer [data-f="plan3"] .uo-opt-t');
    return !!(t && B2G1_RE.test(t.textContent || ''));
  }

  function checkOffer() {
    var next = cardSaysB2G1();
    if (next !== b2g1) {
      b2g1 = next;
      var i, fb = root.querySelectorAll('[data-ddn2-fb]');
      for (i = 0; i < fb.length; i++) fb[i].hidden = b2g1;
      var on = root.querySelectorAll('[data-ddn2-b2g1]');
      for (i = 0; i < on.length; i++) on[i].hidden = !b2g1;
      root.classList.toggle('ddn2--b2g1', b2g1);
      renderSticky();
    }
    return b2g1;
  }

  /* ---------- 2. Gift count ---------- */
  function syncGifts() {
    var box = document.getElementById('uo-offer');
    var source = box && (box.hasAttribute('data-uo-sale-gifts') ? box : box.querySelector('[data-uo-sale-gifts]'));
    var raw = source ? source.getAttribute('data-uo-sale-gifts') : '';
    var count = /^\d+$/.test(raw || '') ? parseInt(raw, 10) : 0;
    // These page tiles name both gifts, so show only when both are confirmed.
    var els = root.querySelectorAll('[data-ddn2-gifts]');
    for (var i = 0; i < els.length; i++) els[i].hidden = count < 2;
    var nums = root.querySelectorAll('span[data-uo-sale-gifts]');
    for (var j = 0; j < nums.length; j++) {
      if (nums[j].textContent !== String(count)) nums[j].textContent = String(count);
    }
  }

  function saleActive() {
    var box = document.getElementById('uo-offer');
    return !!(box && box.getAttribute('data-uo-sale-active') === '1');
  }

  /* ---------- 3. Sticky ---------- */
  var sticky = document.getElementById('ddn2-sticky');
  var stickyL1 = sticky ? sticky.querySelector('.ddn2-sticky__l1') : null;
  var stickyL2 = sticky ? sticky.querySelector('.ddn2-sticky__l2') : null;
  var stickyA = stickyL1 ? stickyL1.innerHTML : '';
  var stickyBtn = sticky ? sticky.querySelector('.ddn2-sticky__btn') : null;
  var passedCause = false;
  var boxVisible = false;
  var stickyState = '';

  function renderSticky() {
    if (!sticky) return;
    var state = b2g1 ? 'B' : 'A';
    if (state === stickyState) return;
    stickyState = state;
    sticky.setAttribute('data-state', state);
    if (state === 'A') {
      stickyL1.innerHTML = stickyA;
      stickyL2.textContent = '90-day money-back guarantee';
      if (stickyBtn) stickyBtn.textContent = 'Get My Offer';
      stickyL2.hidden = false;
    } else {
      stickyL1.textContent = 'First Month Free';
      if (stickyBtn) stickyBtn.textContent = 'Get My Free Month';
      stickyL2.hidden = false;
      stickyL2.textContent = '90-day money-back guarantee';
    }
  }

  function updateSticky() {
    if (!sticky) return;
    var causeEnd = document.getElementById('ddn2-cause-end');
    if (!passedCause && causeEnd && causeEnd.getBoundingClientRect().top < 0) {
      passedCause = true;
      renderSticky();
    }
    var show = window.pageYOffset > 600 && !boxVisible;
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function initSticky() {
    if (!sticky) return;
    sticky.hidden = false;
    sticky.setAttribute('aria-hidden', 'true');
    renderSticky();
    var box = document.getElementById('uo-offer');
    var sentinel = document.getElementById('ddn2-cause-end');
    if ('IntersectionObserver' in window) {
      if (box) {
        new IntersectionObserver(function (entries) {
          boxVisible = entries[0].isIntersecting;
          updateSticky();
        }).observe(box);
      }
      if (sentinel) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          if (!e.isIntersecting && e.boundingClientRect.top < 0 && !passedCause) {
            passedCause = true;
            renderSticky();
          }
        }).observe(sentinel);
      }
    } else if (sentinel) {
      window.addEventListener('scroll', function () {
        if (!passedCause && sentinel.getBoundingClientRect().top < 0) { passedCause = true; renderSticky(); }
      }, { passive: true });
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();
    var btn = sticky.querySelector('.ddn2-sticky__btn');
    if (btn) {
      btn.addEventListener('click', function () {
        var target = document.getElementById('uo-offer');
        if (target) scrollToEl(target);
        fire('lp_ddn2_sticky_click', { state: stickyState });
      });
    }
  }

  /* ---------- 4. Lazy loops ---------- */
  function startLoop(v) {
    if (!v.getAttribute('src')) {
      var s = v.getAttribute('data-ddn2-src');
      if (!s) return;
      v.src = s;
    }
    v.muted = true;
    var p = v.play();
    if (p && typeof p.catch === 'function') p.catch(function () { /* poster stays */ });
  }

  function initLoops() {
    var vids = root.querySelectorAll('video.ddn2-loop');
    if (!vids.length || reduceMotion) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < vids.length; i++) startLoop(vids[i]);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (v.offsetParent === null) return; /* display:none (e.g. desktop close still) */
        if (e.isIntersecting) startLoop(v);
        else if (!v.paused) v.pause();
      });
    }, { rootMargin: '200px 0px' });
    for (var j = 0; j < vids.length; j++) io.observe(vids[j]);
  }

  /* ---------- 5. Chart ---------- */
  function initChart() {
    var chart = root.querySelector('[data-ddn2-chart]');
    if (!chart || reduceMotion || !('IntersectionObserver' in window)) return;
    var bars = chart.querySelectorAll('[data-ddn2-bar]');
    if (!bars.length) return;
    var i;
    for (i = 0; i < bars.length; i++) {
      bars[i].style.transition = 'none';
      bars[i].style.height = '0%';
      var num = bars[i].querySelector('[data-ddn2-num]');
      if (num) num.textContent = '0';
    }
    function endState() {
      for (var q = 0; q < bars.length; q++) {
        bars[q].style.transition = 'none';
        bars[q].style.height = bars[q].getAttribute('data-ddn2-bar') + '%';
        var nq = bars[q].querySelector('[data-ddn2-num]');
        if (nq) nq.textContent = bars[q].getAttribute('data-ddn2-bar');
      }
    }
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var passed = e.boundingClientRect.top < 0;
      if (e.intersectionRatio < 0.4 && !passed) return;
      io.disconnect();
      if (!e.isIntersecting) { endState(); return; }
      var start = null;
      var DUR = 600;
      for (var k = 0; k < bars.length; k++) {
        bars[k].style.transition = 'height ' + DUR + 'ms cubic-bezier(0.22, 1, 0.36, 1)';
        bars[k].style.height = bars[k].getAttribute('data-ddn2-bar') + '%';
      }
      function tick(ts) {
        if (start === null) start = ts;
        var t = Math.min(1, (ts - start) / DUR);
        var eased = 1 - Math.pow(1 - t, 3);
        for (var m = 0; m < bars.length; m++) {
          var n = bars[m].querySelector('[data-ddn2-num]');
          if (n) n.textContent = String(Math.round(eased * parseInt(bars[m].getAttribute('data-ddn2-bar'), 10)));
        }
        if (t < 1) window.requestAnimationFrame(tick);
      }
      window.requestAnimationFrame(tick);
    }, { threshold: [0, 0.4] });
    io.observe(chart);
  }

  /* ---------- 6. Smooth scroll ---------- */
  function scrollToEl(el) {
    var top = window.pageYOffset + el.getBoundingClientRect().top - HEADER_OFFSET;
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    } else {
      window.scrollTo(0, top);
    }
  }

  root.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a || a.closest('.uo')) return;
    var id = a.getAttribute('href').slice(1);
    var target = id ? document.getElementById(id) : null;
    if (!target) return;
    e.preventDefault();
    scrollToEl(target);
    if (id === 'uo-offer') {
      fire('lp_ddn2_cta_click', { cta: a.getAttribute('data-ddn2-cta') || '', b2g1: b2g1 });
    }
  });

  /* ---------- init ---------- */
  function init() {
    checkOffer();
    syncGifts();
    initSticky();
    initLoops();
    initChart();
    var box = document.getElementById('uo-offer');
    if (box && 'MutationObserver' in window) {
      var mo = new MutationObserver(function () {
        syncGifts();
        checkOffer();
        renderSticky();
      });
      mo.observe(box, { subtree: true, childList: true, attributes: true, characterData: true, attributeFilter: ['data-uo-sale-gifts', 'data-uo-sale-active', 'data-uo-sale-name'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
